import * as types from '../actions/actionType';
export default function apiErroReducer(state = {}, action) {
    switch (action.type) {
        case types.API_ERROR:
            return action.error;
        default:
            return state;
    }
}
